import React from "react";
import { Alert, AlertTitle, AlertDescription } from "./ui/Alert";

const variantMap = {
  danger: "danger",
  warning: "warning",
  success: "success",
  info: "info",
};

const ErrorResponse = ({ title, type, message }) => {
  const variant = variantMap[type] || "danger";

  return (
    <Alert variant={variant} className="my-4">
      <AlertTitle>{title || "Error Encountered"}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};

export default ErrorResponse;
